<template><rgbw-control-editor :objData="objData" :white-enabled="false" realtime /></template>
<script>
import RgbwControlEditor from "components/content/control-toast/rgbw-control-editor";
export default { props: { objData: Object }, components: { RgbwControlEditor } };
</script>
